import './css/globalStyles.css'
import './css/fonts.css'

import { responsiveFontSizes } from '@mui/material'
import { createTheme } from '@mui/material/styles'
import {
  breakpoint,
  light,
  shadow,
  typography,
  spacing,
  shape,
  transition,
  zIndex,
} from './maps'

let theme = createTheme({
  breakpoints: breakpoint,
  palette: light,
  shadows: shadow,
  typography,
  spacing,
  shape,
  transitions: transition,
  zIndex,
})

theme = responsiveFontSizes(theme)

export default theme
